import ApiBase from '../../ApiBase';

class Tag extends ApiBase {
    route = '/cms/elements/tags';
}

export default new Tag();
